import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import RepairService from "../../services/RepairService";

const DetailModal = ({ show, handleClose, selectedDon }) => {
  // Ensure hooks are called unconditionally
  const [ChiPhi, setCP] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!selectedDon) return;

    const fetchChiPhi = async () => {
      try {
        const response = await RepairService.Lay_CP_Bd_Sc(selectedDon.id);
        if (response && response.data) {
          setCP(response.data);
        } else {
          setCP([]);
        }
      } catch (error) {
        console.error("Lỗi khi tải chi phí:", error);
        setCP([]);
        setErrorMessage("Không thể tải chi phí. Vui lòng thử lại sau.");
      }
    };

    fetchChiPhi();
  }, [selectedDon]);

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {selectedDon ? `Báo giá đơn ${selectedDon.id}` : "Chi tiết đơn"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!selectedDon ? (
          <p>Không có thông tin đơn.</p>
        ) : (
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Biển kiểm soát</Form.Label>
                  <Form.Control type="text" value={selectedDon.bien_kiem_soat} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Ngày sửa chữa</Form.Label>
                  <Form.Control
                    type="text"
                    value={new Date(selectedDon.ngay_sua_chua).toLocaleDateString()}
                    disabled
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Loại</Form.Label>
                  <Form.Control type="text" value={selectedDon.loai} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Loại xe</Form.Label>
                  <Form.Control type="text" value={selectedDon.loai_xe} disabled />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Trạm</Form.Label>
                  <Form.Control type="text" value={selectedDon.tram} disabled />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Tài xế</Form.Label>
                  <Form.Control type="text" value={selectedDon.tai_xe} disabled />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Form.Group>
                  <Form.Label>Ghi chú</Form.Label>
                  <Form.Control as="textarea" rows={2} value={selectedDon.ghi_chu} disabled />
                </Form.Group>
              </Col>
            </Row>

            {/* Chi phí Section */}
            <hr />
            <h5>Chi phí</h5>
            {errorMessage && <p className="text-danger">{errorMessage}</p>}
            {ChiPhi && ChiPhi.length > 0 ? (
              <ul>
                {ChiPhi.map((item, index) => (
                  <li key={index}>{item.name} - {item.gia} VND</li>
                ))}
              </ul>
            ) : (
              <p>Không có chi phí nào.</p>
            )}

            <hr />
            <Form.Group>
              <Form.Label>Giá</Form.Label>
              <Form.Control type="number" value={selectedDon.gia} disabled />
            </Form.Group>
          </Form>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Đóng
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetailModal;
